import React, { useState, useContext, useEffect} from 'react';

import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import {
  combineValidators,
  composeValidators,
  isRequired,
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'
import { IAdminDocument } from '../../../../App/models/AdminDocument';
import { Accordion, Card } from "react-bootstrap";
import { Button, Icon, Label, Popup, Form, Segment, Grid, Dropdown, Divider } from "semantic-ui-react";
import { DocumentQuestionFormValues, IDocumentQuestion } from '../../../../App/models/AdminDocumentQuestion';

import DnDInput from '../../../../App/common/form/DnDInput';


const validate = combineValidators({
  documentTypeId: composeValidators(
    isRequired('documentTypeId'),
  )(),

  documentQuestionId: composeValidators(
    isRequired('documentQuestionId'),
  )(),

  documentQuestion: composeValidators(
    isRequired('documentQuestion'),
  )(),

  documentType: composeValidators(
    isRequired('documentType'),
  )(),

  requirements: composeValidators(
    isRequired('requirements'),
  )(),

});

interface DocumentsParams {
  document: IAdminDocument;

}


const AdminDocumentQuestionForm: React.FC<DocumentsParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { submitting, AdminDocumentQuestions, loadAdminDocumentQuestions, deleteDocumentQuestion, createAdminDocumentQuestion, editAdminDocumentQuestion } = rootStore.adminDocumentQuestionStore;
  const { getAdminQuestionDropdown } = rootStore.adminQuestionStore;

  const [disabled, setDisabled] = useState(true);
  const [docTypeSelection, setDocTypeSelection] = useState();
  const [docTypeTextSelection, setDocTypeTextSelection] = useState();


  const [adminDocumentQuestion] = useState(new DocumentQuestionFormValues(match.document.id));
  const [loading] = useState(false);

  useEffect(() => {

    loadAdminDocumentQuestions(match.document!.id);
  }, [loadAdminDocumentQuestions]);



  const handleDocTypeChange = (event: any, data: any) => {
    setDocTypeSelection(data.value);
    setDocTypeTextSelection(data.text);
    setDisabled(false);
  }

  const linkQuestion = async () => {

    // @ts-ignore
    adminDocumentQuestion.documentQuestionId = docTypeSelection;

    adminDocumentQuestion.documentType = match.document.type;

    // @ts-ignore
    adminDocumentQuestion.documentQuestion = docTypeTextSelection;

    await createAdminDocumentQuestion(adminDocumentQuestion);
  }


  const handleFinalFormSubmit = async (values: any) => {
    const { ...adminDocumentQuestion } = values;
    await editAdminDocumentQuestion(adminDocumentQuestion);
  }

  return (
    <Segment>
      <Label>
        Document: {match.document.type}
      </Label>

      <Grid columns={2}>
        <Grid.Column >
          <Dropdown
            placeholder='Select a Question'
            fluid
            search
            selection
            options={getAdminQuestionDropdown()}
            onChange={handleDocTypeChange}
          />
        </Grid.Column>
        <Grid.Column >
          <Button
            loading={submitting}
            content={"link Question"}
            labelPosition={'left'}
            icon={"plus circle"}
            floated={"right"}
            className={'rl-btn'}
            size={'tiny'}
            disabled={disabled}
            onClick={linkQuestion}
          />
        </Grid.Column>
      </Grid>
      <Divider />

      <div className={'document-content'}>

        {AdminDocumentQuestions.map((requestReviewDoc: IDocumentQuestion) => (
          <Accordion defaultActiveKey="0" key={requestReviewDoc.documentQuestionId+requestReviewDoc.documentTypeId}>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Card.Header} variant="link" eventKey="0" className={"accordion-header"} >
                  <Label as='a'>
                    <Icon name='file alternate' />
                    {requestReviewDoc.documentQuestion}
                  </Label>

                  <Popup
                    content={"Unlink Question from document"}
                    trigger={
                      <Button size='tiny'
                        loading={submitting}
                        floated='right'
                        color='red'
                        onClick={() => deleteDocumentQuestion(requestReviewDoc.documentTypeId, requestReviewDoc.documentQuestionId)}
                      >
                        <Icon name="delete" />
                      </Button>
                    }
                  />
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0" >
                <Card.Body>
                  <FinalForm
                    validate={validate}
                    initialValues={requestReviewDoc}
                    onSubmit={handleFinalFormSubmit}

                    render={({ handleSubmit, invalid, pristine }) => (
                      <Form onSubmit={handleSubmit} loading={loading}>


                        <Field
                          rows={4}
                          name='requirements'
                          placeholder='requirements'
                          value={requestReviewDoc.requirements}
                          component={DnDInput}
                          formId={requestReviewDoc.documentQuestionId}
                        />
                        <Button
                          loading={submitting}
                          disabled={loading}//|| invalid || pristine}
                          floated='right'
                          positive
                          type='submit'
                          content='update'
                        />

                      </Form>
                    )}
                  />

                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        ))}
      </div>


    </Segment>
  );
};

export default observer(AdminDocumentQuestionForm);
